// ===== K&N GIVEAWAYS V5 — ULTIMATE JS =====

// COUNTDOWN
(function() {
  const end = new Date('2026-10-26T23:59:00-04:00');
  function update() {
    const diff = end - new Date();
    if (diff <= 0) return;
    const d = Math.floor(diff / 864e5);
    const h = Math.floor((diff % 864e5) / 36e5);
    const m = Math.floor((diff % 36e5) / 6e4);
    const s = Math.floor((diff % 6e4) / 1e3);
    ['', '2'].forEach(function(sx) {
      var el = document.getElementById('cd-days' + sx);
      if (el) {
        el.textContent = String(d).padStart(2, '0');
        document.getElementById('cd-hours' + sx).textContent = String(h).padStart(2, '0');
        document.getElementById('cd-mins' + sx).textContent = String(m).padStart(2, '0');
        document.getElementById('cd-secs' + sx).textContent = String(s).padStart(2, '0');
      }
    });
  }
  update();
  setInterval(update, 1000);
})();

// SCROLL REVEAL
(function() {
  var reveals = document.querySelectorAll('.reveal');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function() { entry.target.classList.add('visible'); }, i * 80);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  reveals.forEach(function(el) { observer.observe(el); });
})();

// TICKER CLONE
(function() {
  document.querySelectorAll('.ticker-content').forEach(function(t) {
    t.innerHTML += t.innerHTML;
  });
})();

// HEADER SCROLL
(function() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    header.style.borderBottomColor = window.scrollY > 100 ? 'rgba(212,33,61,0.15)' : 'rgba(255,255,255,0.05)';
  }, { passive: true });
})();

// ===== FOMO: FAKE LIVE NOTIFICATIONS =====
(function() {
  var names = ['Marc', 'Sophie', 'Alex', 'Mathieu', 'Julie', 'Seb', 'Maxime', 'Véro', 'Pat', 'Karine', 'Nic', 'Steph', 'Dave', 'Mélanie', 'Fred', 'Jess', 'Phil', 'Marie', 'Sam', 'Isa', 'Yan', 'Jo', 'Matt', 'Audrey', 'Ben', 'Caro', 'Dan', 'Émilie', 'Hugo', 'Laurie'];
  var cities = ['Montréal', 'Québec', 'Laval', 'Gatineau', 'Longueuil', 'Sherbrooke', 'Lévis', 'Trois-Rivières', 'Terrebonne', 'Saint-Jean', 'Drummondville', 'Granby', 'Blainville', 'Rimouski', 'Shawinigan'];
  var products = [
    { name: 'Billet Bronze', entries: '2 entrées' },
    { name: 'Billet Or', entries: '5 entrées' },
    { name: 'Billet Platine', entries: '20 entrées' },
    { name: 'Billet Platine', entries: '20 entrées' }
  ];
  var minutes = [2, 3, 5, 7, 8, 11, 14, 18, 22, 26];

  function getRandom(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  function showNotification() {
    var existing = document.querySelector('.fomo-notification');
    if (existing) existing.remove();

    var n = getRandom(names);
    var c = getRandom(cities);
    var p = getRandom(products);
    var m = getRandom(minutes);

    var el = document.createElement('div');
    el.className = 'fomo-notification';
    el.innerHTML = '<div class="fomo-icon">🎟️</div><div class="fomo-text"><strong>' + n + '</strong> de ' + c + ' vient d\'acheter un <strong>' + p.name + '</strong> (' + p.entries + ')<div class="fomo-time">Il y a ' + m + ' minutes</div></div><button class="fomo-close" onclick="this.parentElement.remove()">✕</button>';
    document.body.appendChild(el);

    setTimeout(function() { el.classList.add('fomo-show'); }, 100);
    setTimeout(function() {
      el.classList.remove('fomo-show');
      setTimeout(function() { if (el.parentElement) el.remove(); }, 500);
    }, 6000);
  }

  // First notification after 8 seconds, then every 25-45 seconds
  setTimeout(showNotification, 8000);
  setInterval(showNotification, 25000 + Math.random() * 20000);
})();

// ===== FAKE VIEWER COUNT =====
(function() {
  function setViewers(n) {
    ['viewer-count', 'viewer-count-2', 'viewer-count-c'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = n;
    });
  }
  var base = 12 + Math.floor(Math.random() * 15);
  setViewers(base);
  setInterval(function() {
    base += Math.floor(Math.random() * 5) - 2;
    if (base < 8) base = 8 + Math.floor(Math.random() * 5);
    if (base > 40) base = 30 + Math.floor(Math.random() * 5);
    setViewers(base);
  }, 5000);
})();

// ===== SOCIAL PROOF COUNTERS =====
(function() {
  // These numbers should be updated manually as sales grow
  var soldBase = 1407;
  var participantsBase = 889;

  function animateCount(id, target) {
    var el = document.getElementById(id);
    if (!el) return;
    var current = 0;
    var step = Math.ceil(target / 40);
    var interval = setInterval(function() {
      current += step;
      if (current >= target) { current = target; clearInterval(interval); }
      el.textContent = current;
    }, 30);
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateCount('sp-entries', soldBase);
        animateCount('sp-entries-2', soldBase);
        animateCount('sp-participants', participantsBase);
        animateCount('sp-participants-2', participantsBase);
        ['sp-last', 'sp-last-2'].forEach(function(id) {
          var el = document.getElementById(id);
          if (el) el.textContent = Math.floor(Math.random() * 8 + 2) + ' min';
        });
        observer.disconnect();
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('.social-proof-grid').forEach(function(el) {
    observer.observe(el);
  });
})();

// ===== PROGRESS BAR =====
(function() {
  var sold = 1407;
  var goal = 20000;
  var pct = Math.min((sold / goal) * 100, 100);
  
  setTimeout(function() {
    ['progress-fill', 'progress-fill-2'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.width = pct + '%';
    });
    ['progress-sold', 'progress-sold-2'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = sold;
    });
  }, 500);
})();

// ===== FLOATING CTA =====
(function() {
  var cta = document.getElementById('floating-cta');
  if (!cta) return;
  window.addEventListener('scroll', function() {
    if (window.scrollY > 600) {
      cta.classList.add('float-show');
    } else {
      cta.classList.remove('float-show');
    }
  }, { passive: true });
})();
